<template>
    <ais-instant-search :search-client="searchClient"
                        :index-name="index"
                        :on-state-change="onStateChanged"
                        :initial-ui-state="initialUiState">

        <ais-refinement-list attribute="active_field_inspections" v-show="false" />

        <div class="px-3 py-3 filters float-right">
            <field-audit-inspectors v-model="selectedInspector" :inspectors="inspectors" @input="reultsById()"></field-audit-inspectors>

            <ais-search-box autofocus placeholder="Search by Technician ..."
            :class-names="{'ais-SearchBox-input': 'form-control', 'ais-SearchBox-form':'form-group form-search pr-3'}"></ais-search-box>

            <div class="refinament mr-2">
                <ais-menu-select class="form-group" attribute="status_text"
                :class-names="{ 'ais-MenuSelect-select': 'form-control'}">
                    <template v-slot:defaultOption>
                        Select Status
                    </template>
                    <template v-slot:item="{ item }">
                        {{ item.label }}
                    </template>
                </ais-menu-select>

            </div>
            <div class="refinament">
                <ais-menu-select class="form-group" attribute="project.county" :limit="100"
                :class-names="{ 'ais-MenuSelect-select': 'form-control'}">
                    <template v-slot:defaultOption>
                        Select County
                    </template>
                    <template v-slot:item="{ item }">
                        {{ item.label }}
                    </template>
                </ais-menu-select>
            </div>

        </div>

        <ais-configure :filters="reultsById()"/>

        <ais-hits>

            <table class="table table-striped table-hover mb-3" slot-scope="{ items }">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Trigger</th>
                    <th>Technician</th>
                    <th>Inspector</th>
                    <th class="text-center">Status</th>
                    <th>Notified At</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="field_inspection in items"
                    :key="field_inspection.id"
                    @click="redirectTo(`/field-inspections/${field_inspection.number}`)"
                    style="height: 60px">

                    <td v-text="field_inspection.number"></td>
                    <td>
                        <div v-text="field_inspection.trigger"></div>
                        <testing-history-overview  :user="field_inspection.technician"></testing-history-overview>
                        <div v-if="field_inspection.notes" class="text-muted text-sm">
                            <b>Note: </b> <span v-text="field_inspection.notes[0].note"></span>
                        </div>
                    </td>
                    <td>
                        <div class="name" v-if="field_inspection.technician" v-text="field_inspection.technician.name"></div>
                        <div class="name" v-else >No technician Assigned</div>

                        <div class="text-info text-sm" v-if="field_inspection.employer && field_inspection.technician.id != field_inspection.employer.id" v-text="field_inspection.employer.name"></div>
                        <div class="text-danger text-sm" v-if="!field_inspection.employer">No Employer Assigned</div>
                    </td>

                    <td v-if="field_inspection.inspector" v-text="field_inspection.inspector.name"></td>
                    <td v-else>No Inspector Assigned</td>

                    <td>
                        <div class="d-flex justify-content-center">
                            <auditable-status :auditable-item="field_inspection"></auditable-status>
                        </div>
                    </td>
                    <td class="text-right" v-text="shortDate(field_inspection.notified_at)"></td>

                </tr>
                </tbody>
            </table>
        </ais-hits>

        <ais-pagination />
    </ais-instant-search>
</template>
<script>
    import algoliasearch from "algoliasearch/lite";

    import ControlState from '@/mixins/ControlAlgoliaSearchState'

    export default {

        mixins:[ControlState],

        props: {
            user: {
                type: Object,
                required: true,
            },
            inspectors: {
                type: Array,
                required: false
            }
        },

        data() {
            return {
                initialStateKey: `search-field-inspections-${this.user.id}-v2`,
                selectedInspector: null,
                searchClient: null,
                initialUiState: {},
                index: null
            };
        },

        created() {
            let key = process.env.MIX_ALGOLIA_APP_ID;
            var secret = process.env.MIX_ALGOLIA_SECRET;
            this.loadInitialState()
            this.loadInitialStateFromLocalStorage()
            this.searchClient = algoliasearch(key, secret)
        },

        methods: {

            loadInitialState(){
                this.index = process.env.MIX_SCOUT_PREFIX + 'field_inspections';
                this.initialUiState[this.index] = {
                    refinementList: {
                        active_field_inspections: ["active"]
                    },
                }
            },

            reultsById() {
                if (this.selectedInspector) return `inspector.id:${this.selectedInspector.id}`
                if (this.user.is_administrator) return
                return `technician.id=${this.user.id} OR (employer.id=${this.user.id}) OR (inspector.id=${this.user.id})`;
            },
        },
    }
</script>
<style scoped>
    @import 'https://cdn.jsdelivr.net/npm/instantsearch.css@7/themes/algolia-min.css';
    .filters{
        display: flex;
        align-items: center;
        margin-left: auto !important;
    }
</style>
